<template>
	<div>
		<SupportBanner />
		<div class="content-zsy">
			<div class="title-wrap">
			        <h3>제휴</h3>
			    </div>
			 <el-tabs v-model="activeName"  @tab-click="handleClick" stretch>
			    <el-tab-pane name="first">
					<div slot="label"> 
						<i class="el-icon-date"></i> 모인비즈플러스
					</div>
					<img src="../../assets/list/document-partnership-img1.png" @click="goCustomsinfoUrl('https://www.moinbizplus.com')" alt="" class="img-responsive center-block" loading="lazy">
				</el-tab-pane>
			    <el-tab-pane name="second">
					<div slot="label">
						<i class="el-icon-date"></i> KC랩스
					</div>
					<img src="../../assets/list/document-partnership-img2.png" @click="goCustomsinfoUrl('https://kclabs.kr')" alt="" class="img-responsive center-block" loading="lazy">
				</el-tab-pane>
			    <el-tab-pane name="third">
					<div slot="label">
						<i class="el-icon-date"></i> LOOKC
					</div>
					<img src="../../assets/list/document-partnership-img3.png"  @click="goCustomsinfoUrl('http://www.lookc.co.kr')" alt="" class="img-responsive center-block" loading="lazy">
				</el-tab-pane>
			    <el-tab-pane name="fourth">
					<div slot="label">
						<i class="el-icon-date"></i> 올라
					</div>
					<img src="../../assets/list/document-partnership-img3-1.png" @click="goCustomsinfoUrl('https://allra.co.kr/about?utm_source=partner&utm_medium=landing&utm_campaign=2410_postteam')" alt="" class="img-responsive center-block" loading="lazy">
					<img src="../../assets/list/document-partnership-img3-2.png" @click="goCustomsinfoUrl('https://allra.co.kr/about?utm_source=partner&utm_medium=landing&utm_campaign=2410_postteam')" alt="" class="img-responsive center-block" loading="lazy">
					<img src="../../assets/list/document-partnership-img3-3.png" @click="goCustomsinfoUrl('https://allra.co.kr/about?utm_source=partner&utm_medium=landing&utm_campaign=2410_postteam')" alt="" class="img-responsive center-block" loading="lazy">
					
				</el-tab-pane>
				<el-tab-pane name="five">
					<div slot="label">
						<i class="el-icon-date"></i> 셀러라이프
					</div>
					<img src="../../assets/list/document-partnership-img5.png" @click="goCustomsinfoUrl('https://sellochomes.co.kr/sellerlife')" alt="" class="img-responsive center-block" loading="lazy">
				</el-tab-pane>
			  </el-tabs>
			  
			  
			  
		</div>
		
	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	export default {
		components: {
			SupportBanner,
		},
		data() {
			return {
				activeName: 'first'
			}
		},
		created() {
		
		},
		methods: {
			handleClick(tab, event) {
				console.log(tab, event);
			},
			goCustomsinfoUrl(url){
				window.open(url, '_blank');
			},
			
		}
	}
</script>

<style scoped>
	.title-wrap{
		text-align: center;
		color: var(--frontground-color);
		margin-bottom: 30px;
	}
	.title-wrap h3 {
	    font-size: 45px;
		font-weight: bold;
		color: var(--frontground-color);
		letter-spacing: -0.025em;
	}
	.img-responsive {
	    display: block;
	    max-width: 100%;
	    height: auto;
	}
	.center-block {
	    display: block;
	    margin-right: auto;
	    margin-left: auto;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 992px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.title-wrap{
			margin-top: 20px;
		}
		.title-wrap h3 {
			font-weight: 700;
			font-size: 30px;
			line-height: 39px;
			text-align: center;
			
		}
	}
</style>